import {
  Input, InputAdornment, Checkbox, FormControlLabel,
} from '@material-ui/core';
import { Tooltip } from '@mui/material';
import React, { useState, useCallback } from 'react';
import DrawerMenu from 'react-modern-drawer';
import clsx from 'clsx';
import CloseBtn from '../../../assets/images/close-drawer.svg';
import SubmitBtn from '../../../assets/images/submit.svg';
import CheckboxIcon from '../../../assets/images/checkbox-unchecked.svg';
import CheckboxSelected from '../../../assets/images/checkbox-selected-blue.svg';
import Button from '../../DesignSystem/button';

import { mapFilterDescriptions as desc, mapFilterNames as names, MAP_COLOR } from '../../../utils/appConstants';

function getSVGLine(innerColor: string, outerColor: string) {
  const available = innerColor !== outerColor;
  const outerRadius = (available) ? '9' : '7';
  const innerRadius = (available) ? '7' : '5';
  const circleColor = (available) ? MAP_COLOR.LIGHT_GREEN : MAP_COLOR.WHITE;

  return (
    <svg width="190" height="32">
      {(available) ? <line x1="32" x2="175" y1="16" y2="16" fill={outerColor} stroke={outerColor} strokeWidth="10" /> : null}
      <line x1="32" x2="175" y1="16" y2="16" fill={innerColor} stroke={innerColor} strokeWidth="5" />
      <circle cx="32" cy="16" r={outerRadius} fill={MAP_COLOR.BLACK} />
      <circle cx="32" cy="16" r={innerRadius} fill={circleColor} />
      <circle cx="175" cy="16" r={outerRadius} fill={MAP_COLOR.BLACK} />
      <circle cx="175" cy="16" r={innerRadius} fill={circleColor} />
    </svg>
  );
}

interface SelectFiltersProps {
  open: boolean;
  onOpen: () => void;
  onClose: (_?:any) => void;
  mapFilters: { available: boolean, consumed: boolean, sold: boolean,
  contract: boolean, demand: boolean, other: boolean }
  setMapFilters: (_?: any) => void;
}

const SelectFilters: React.FC<SelectFiltersProps> = ({
  open, onClose, onOpen, mapFilters, setMapFilters,
}) => {
  const [tempMapFilters, setTempMapFilters] = useState(mapFilters);
  const handleFiltersChange = useCallback((id: string) => {
    setTempMapFilters((prev: any) => {
      return {
        ...prev,
        [id]: !prev[id],
      };
    });
  }, [setMapFilters]);
  const handleSubmit = useCallback(() => {
    setMapFilters(tempMapFilters);
    onClose();
  }, [tempMapFilters, mapFilters, setMapFilters, onClose]);

  const placement = 'left-start';
  const mapFilterEqual = (
    (tempMapFilters.available == mapFilters.available)
    && (tempMapFilters.consumed == mapFilters.consumed)
    && (tempMapFilters.sold == mapFilters.sold)
    && (tempMapFilters.demand == mapFilters.demand)
    && (tempMapFilters.contract == mapFilters.contract)
    && (tempMapFilters.other == mapFilters.other));

  return (
    <DrawerMenu
      enableOverlay
      className={clsx('search-ne', open && 'open')}
      open={open}
      onClose={() => onClose()}
      duration={100}
      direction="right"
    >
      <div className="close-drawer-btn" onClick={() => (open ? onClose() : onOpen())}>
        <img src={CloseBtn} alt="Close Drawer" />
      </div>
      <div className="select-ne-map">
        <label className="title">Select Filters</label>
        <div className="subtitle">
          My Network
          <label>Map Representation</label>
        </div>
        <Tooltip
          classes={{
            tooltip: 'tooltip',
          }}
          title={desc.available}
          // arrow
          placement={placement}
          disableInteractive
          disableTouchListener
        >
          <div>
            <FormControlLabel
              control={(
                <Checkbox
                  classes={{
                    root: 'show-ports-checkbox',
                  }}
                  color="default"
                  checked={tempMapFilters.available}
                  onChange={() => handleFiltersChange('available')}
                  icon={<img width="30px" src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                  checkedIcon={<img width="30px" src={CheckboxSelected} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                  name="available"
                />
              )}
              label={names.available}
            />
            <div className="canvas-representation">
              {getSVGLine(MAP_COLOR.WHITE, MAP_COLOR.GREEN)}
            </div>
          </div>
        </Tooltip>
        <Tooltip
          classes={{
            tooltip: 'tooltip',
          }}
          title={desc.consumed}
          // arrow
          placement={placement}
          disableInteractive
          disableTouchListener
        >
          <div>
            <FormControlLabel
              control={(
                <Checkbox
                  classes={{
                    root: 'show-ports-checkbox',
                  }}
                  color="default"
                  checked={tempMapFilters.consumed}
                  onChange={() => handleFiltersChange('consumed')}
                  icon={<img width="30px" src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                  checkedIcon={<img width="30px" src={CheckboxSelected} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                  name="consumed"
                />
              )}
              label={names.consumed}
            />
            <div className="canvas-representation">
              {getSVGLine(MAP_COLOR.LIGHT_GREEN, MAP_COLOR.LIGHT_GREEN)}
              {getSVGLine(MAP_COLOR.YELLOW, MAP_COLOR.YELLOW)}
            </div>
          </div>
        </Tooltip>
        <Tooltip
          classes={{
            tooltip: 'tooltip',
          }}
          title={desc.static}
          // arrow
          placement={placement}
          disableInteractive
          disableTouchListener
        >
          <div>
            <FormControlLabel
              control={(
                <Checkbox
                  classes={{
                    root: 'show-ports-checkbox',
                  }}
                  color="default"
                  checked={tempMapFilters.sold}
                  onChange={() => handleFiltersChange('sold')}
                  icon={<img width="30px" src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                  checkedIcon={<img width="30px" src={CheckboxSelected} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                  name="sold"
                />
              )}
              label={names.static}
            />
            <div className="canvas-representation">
              {getSVGLine(MAP_COLOR.GREY, MAP_COLOR.GREY)}
            </div>
          </div>
        </Tooltip>
        <div className="subtitle">
          Marketplace
          <label>Map Representation</label>
        </div>

        <Tooltip
          classes={{
            tooltip: 'tooltip',
          }}
          title={desc.demand}
          placement={placement}
          disableInteractive
          disableTouchListener
        >
          <div>
            <FormControlLabel
              control={(
                <Checkbox
                  classes={{
                    root: 'show-ports-checkbox',
                  }}
                  color="default"
                  checked={tempMapFilters.demand}
                  onChange={() => handleFiltersChange('demand')}
                  icon={<img width="30px" src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                  checkedIcon={<img width="30px" src={CheckboxSelected} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                  name="demand"
                />
              )}
              label={names.demand}
            />
            <div className="canvas-representation">
              {getSVGLine(MAP_COLOR.WHITE, MAP_COLOR.BLACK)}
            </div>
          </div>
        </Tooltip>
        <Tooltip
          classes={{
            tooltip: 'tooltip',
          }}
          title={desc.contract}
          // arrow
          placement={placement}
          disableInteractive
          disableTouchListener
        >
          <div>
            <FormControlLabel
              control={(
                <Checkbox
                  classes={{
                    root: 'show-ports-checkbox',
                  }}
                  color="default"
                  checked={tempMapFilters.contract}
                  onChange={() => handleFiltersChange('contract')}
                  icon={<img width="30px" src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                  checkedIcon={<img width="30px" src={CheckboxSelected} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                  name="contract"
                />
              )}
              label={names.contract}
            />
            <div className="canvas-representation">
              {getSVGLine(MAP_COLOR.WHITE, MAP_COLOR.BLACK)}
            </div>
          </div>
        </Tooltip>
        <Tooltip
          classes={{
            tooltip: 'tooltip',
          }}
          title={desc.other}
          // arrow
          placement={placement}
          disableInteractive
          disableTouchListener
        >
          <div>
            <FormControlLabel
              control={(
                <Checkbox
                  classes={{
                    root: 'show-ports-checkbox',
                  }}
                  color="default"
                  checked={tempMapFilters.other}
                  onChange={() => handleFiltersChange('other')}
                  icon={<img width="30px" src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                  checkedIcon={<img width="30px" src={CheckboxSelected} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                  name="other"
                />
              )}
              label={names.other}
            />
            <div className="canvas-representation">
              {getSVGLine(MAP_COLOR.BLACK, MAP_COLOR.BLACK)}
            </div>
          </div>
        </Tooltip>
        <div>
          <Button disabled={mapFilterEqual} variant="primary" node="Update Map Filters" type="submit" onClick={() => handleSubmit()} />
        </div>
      </div>
    </DrawerMenu>
  );
};

export default SelectFilters;
